import { ApiMethods } from "../../constants/apiMethods";
import { apiFetchOAuthWithClaims } from "../../services/apiClient";

const baseURL = `${process.env.REACT_APP_API_URL}/catalog`;

export class CatalogApi {
    async getOrganizationSelector(): Promise<any> {
        const url = `${baseURL}/organizations`;
        return apiFetchOAuthWithClaims(ApiMethods.GET, url).withBody({}).execute<any>();
    }
}
